import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './password-input.css';

function PasswordInput({
  value,
  onChange,
  placeholder,
  showPassword,
  setShowPassword,
  required = true,
  inputId,
}) {
  return (
    <div style={{ position: 'relative', marginBottom: '1rem' }}>
      <input
        id={inputId}
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        style={{ width: '100%', paddingRight: '2.5rem' }}
      />
      <button
        type="button"
        onClick={() => setShowPassword((v) => !v)}
        className="password-toggle-btn"
        aria-label={
          showPassword
            ? `Hide ${placeholder?.toLowerCase()}`
            : `Show ${placeholder?.toLowerCase()}`
        }
        tabIndex={0}
      >
        {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
      </button>
    </div>
  );
}

export default PasswordInput;
